const reactQueryConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
};

export default reactQueryConfig;
